var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineStore } from "pinia";
import { ref } from "vue";
import SupportEndpoints from "src/shared/api/support/SupportEndpoints";
import { SupportUpdateMutable } from "./model/SupportUpdateMutable";
import { toPromise } from "src/shared/api/promise";
export const useSupportStore = defineStore("supportStore", () => {
    const support = ref();
    const fetchSupport = () => __awaiter(void 0, void 0, void 0, function* () {
        const supportResponse = yield toPromise(SupportEndpoints.getSupport());
        support.value = new SupportUpdateMutable(supportResponse);
    });
    const getSupport = () => {
        return support.value;
    };
    const updateSupport = (supportData) => __awaiter(void 0, void 0, void 0, function* () {
        yield toPromise(SupportEndpoints.editSupport(supportData));
        yield fetchSupport();
    });
    return {
        support,
        fetchSupport,
        getSupport,
        updateSupport,
    };
});
